import React, { Component } from 'react';
import {Bar, Chart} from 'react-chartjs-2';

const data = {
        labels: ["Penn State", "Oklahoma", "Illinois", "Nebraska", "Stanford", "Michigan", "California", "Southern Illinois", "Iowa State", "Ohio State", "Florida State", "UCLA", "Arizona State", "Chicago", "Indiana State", "Iowa", "Michigan State", "Southern California", "Temple"],
        datasets: [{
            label: "NCAA Gymnastics Championships Wins",
            backgroundColor: ["#0066FF",
                              "#841617",
                              "#003C7D",
                              "#c60202",
                              "#8C1515",
                              "#00274c",
                              "#5e7aa9",
                              "#660000",
                              "#cc0000",
                              "#BB0000",
                              "#862633",
                              "#536895",
                              "#990033",
                              "#800000",
                              "#0047b6",
                              "#FFE100",
                              "#18453B",
                              "#990000",
                              "#990033"],
            borderColor:     ["#0066FF",
                              "#841617",
                              "#003C7D",
                              "#c60202",
                              "#8C1515",
                              "#00274c",
                              "#5e7aa9",
                              "#660000",
                              "#cc0000",
                              "#BB0000",
                              "#862633",
                              "#536895",
                              "#990033",
                              "#800000",
                              "#0047b6",
                              "#FFE100",
                              "#18453B",
                              "#990000",
                              "#990033"],
            data: [12, 12, 10, 8, 8, 6, 4, 4, 3, 3, 2, 2, 1, 1, 1, 1, 1, 1, 1],
            fill: false,
        }],
        wins: [
          ["1948", "1953", "1954", "1957", "1959", "1960", "1961", "1965", "1976", "2000", "2004", "2007"],
          ["1977", "1978", "1991", "2002", "2003", "2005", "2006", "2008", "2015", "2016", "2017", "2018"],
          ["1939", "1940", "1941", "1942", "1950", "1955", "1956", "1958", "1989", "2012"],
          ["1979", "1980", "1981", "1982", "1983", "1988", "1990", "1994"],
          ["1992", "1993", "1995", "2009", "2011", "2019", "2021", "2022"],
          ["1963", "1970", "1999", "2010", "2013", "2014"],
          ["1968", "1975", "1997", "1998"],
          ["1964", "1966", "1967", "1972"],
          ["1971", "1973", "1974"],
          ["1985", "1996", "2001"],
          ["1951", "1952"],
          ["1984", "1987"],
          ["1986"],
          ["1938"],
          ["1977"],
          ["1969"],
          ["1958"],
          ["1962"],
          ["1949"]]
    };

class NCAAChamps extends Component {
  constructor(props) {
      super(props);
      this.state = {
        data: data
      };
  }
  componentDidMount() {
    Chart.pluginService.register({
      afterDatasetsDraw: () => {
        if(this.refs.chart !== undefined){
          let ctx = this.refs.chart.chart_instance.chart.ctx;
          ctx.font = "14px Verdana";
          ctx.fillStyle = "#ffffff";
          ctx.textAlign = "center";
          ctx.textBaseline = "bottom";

          this.refs.chart.chart_instance.chart.config.data.datasets.forEach(function (dataset) {
            const dataArray = dataset.data;
            var keys = Object.keys(dataset._meta);
            keys.sort(function(a, b){return b-a});
            var indexNum = keys[0];
            if(dataset._meta[indexNum] !== undefined){
              dataset._meta[indexNum].data.forEach(function (bar, index) {
                  ctx.fillText(dataArray[index], bar._view.x, bar._view.y+25);
              });
            }
          })
        }
      }
    });
  }

  render() {
    var dark = document.body.classList.contains('dark-theme');
    return (
      <div className="chart-container">
        <Bar ref="chart" data={this.state.data}
          width={100}
          height={50}
          options={{
            maintainAspectRatio: false,
            responsive: true,
            title:{
              display: true,
              text: 'NCAA Gymnastics Championship Wins',
              fontColor: dark ? "#DDD" : 'rgba(20,20,20,0.25)'
            },
            scales: {
            	yAxes: [{
              		ticks: {
                    	beginAtZero:true,
                      fontColor: dark ? "#aaa" : 'rgba(20,20,20,0.25)',
                	},
                  gridLines: {
                    color: dark ? 'rgba(100,100,100,0.25)' : 'rgba(20,20,20,0.25)',
                  }
            	}],
              xAxes: [{
              		ticks: {
                    	beginAtZero:true,
                      fontColor: dark ? "#aaa" : 'rgba(20,20,20,0.25)',
                	},
                  gridLines: {
                    color: dark ? 'rgba(100,100,100,0.25)' : 'rgba(20,20,20,0.25)',
                  }
            	}]
          	},
            tooltips: {
              position: 'average',
              mode: 'index',
              titleFontSize: 20,
              bodyFontSize: 15,
              backgroundColor: 'rgba(0,0,0,1)',
              callbacks: {
                  afterLabel: function(tooltipItem, data) {
                      return data.wins[tooltipItem.index];
                  }
              },
            },
            legend: {
              display: false
            }
          }}
        />
      </div>
    );
  }
}

export default NCAAChamps;



// WEBPACK FOOTER //
// ./src/components/NCAAChamps.js